<template>
    <li>
        <router-link :to="`${url}/${slug}`">
            <span>{{ title }}</span>
        </router-link>
        <ul v-if="item.children?.length">
            <BaseLink v-for="(children, i) in item.children" :key="i" :item="children" :url="fullUrl" />
        </ul>
    </li>
</template>

<script>
// import BaseLink from './BaseLink.vue';

export default {
    name: "BaseLink",
    // components: {
    //     'base-link': BaseLink,
    // },
    props: {
        url: {
            type: String,
            required: true,
        },
        item: {
            type: Object,
            required: true,
        },
    },
    computed: {
        fullUrl: function () {
            let fullUrl = this.url + '/' + this.slug;
            if(this.item.sub_url){
                return fullUrl + '/' + this.item.sub_url;
            }
            return fullUrl;
        },
        title: function (){
            return this.item.title.en ?? this.item.title;
        },
        slug: function (){
            return this.item.slug.en ?? this.item.slug;
        }
    }
};
</script>
